/**
 * Smart Shikka Specialist Advisors Preview — Types
 *
 * Static specialist advisor metadata types.
 * Source: github.com/msitarzewski/agency-agents (MIT License)
 * These are NOT executors. Preview only, dry-run only.
 */
export const AGENT_SAFETY_FLAGS = Object.freeze({
    previewOnly: true,
    dryRunOnly: true,
    realExecutionEnabled: false,
    networkAllowed: false,
    fileMutationAllowed: false,
    commandExecutionAllowed: false,
    browserActionAllowed: false,
    providerCallAllowed: false,
    requiresOwnerApproval: true,
    permissionScope: 'task_only',
    permissionRevokedOnTaskEnd: true,
});
export const AGENCY_AGENTS_PREVIEW_VERSION = '0.1.105';
export const AGENCY_AGENTS_SOURCE_ATTRIBUTION = 'Adapted from github.com/msitarzewski/agency-agents (MIT License). AgentLand Contributors.';
export const AGENCY_AGENTS_LICENSE_NOTICE = 'MIT License. Copyright (c) 2025 AgentLand Contributors. Attribution and license notice required.';
//# sourceMappingURL=agencyAgentsPreviewTypes.js.map